var map = {
	"./bonus_symbol_0.png": 95366,
	"./bonus_symbol_1.png": 34383,
	"./bonus_symbol_2.png": 15476,
	"./bonus_symbol_3.png": 36605,
	"./bonus_symbol_4.png": 40258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40145;